import React from 'react';

const EDMain = () => {
  return (
    <div className="page-content">
      <h3>ED</h3>
      <div className="content-section">
        <h5>1. 시나리오 정의</h5>
        <p>목적: 테스트하고자 하는 상황(예: 도시 주행, 고속도로, 비상 상황 등)을 명확히 설정</p>
        <ul>
          <li>도로 구조 (교차로, 차선, 신호등 등)</li>
          <li>주변 객체 (보행자, 차량, 자전거 등)</li>
          <li>환경 조건 (날씨, 시간대, 조명 등)</li>
          <li>차량의 행동 (정지, 회전, 차선 변경 등)</li>
        </ul>
      </div>
      <div className="content-section">
        <h5>2. 실차테스트 데이터 획득</h5>
        <p>목적: 테스트하고자 하는 상황(예: 도시 주행, 고속도로, 비상 상황 등)에 대한 데이터 획득</p>
        <ul>
          <li>Rosbag 데이터 획득</li>
        </ul>
      </div>
    </div>
  );
};

export default EDMain;